/**
 * IMPORTANT: this file is deprecated. All of these colors should be moved to
 * the theme instead.
 */
/**
 * The application's definition of the default color black.
 */
const BLACK = '#111111';
/**
 * The application's color palette.
 */
export const ColorPalette = {
    /**
     * The application's background color.
     */
    appBackground: BLACK,
    /**
     * The application's definition of the default color black. Generally,
     * expected to be kept in sync with the application's background color for
     * the sake of consistency.
     */
    black: BLACK,
    blue: '#17A0DB',
    blueHighlight: '#1081b2',
    darkGrey: '#555555',
    green: '#40b183',
    lightGrey: '#AAAAAA',
    red: '#D00000',
    transparent: 'rgba(0, 0, 0, 0)',
    white: '#FFFFFF'
};
